export default __webpack_public_path__ + "images/person-placeholder.jpeg";